import { Component, OnInit } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { getAppThemeName } from 'src/app/core/functions/common.function';
import { ModalInfo } from 'src/app/core/interfaces/common';
import {CommonService} from "../../../services/common.service";
import {PBHeaderModule} from "@db/db-components";
import {CommonModule} from "@angular/common";

@Component({
  selector: 'pb-app-header',
  templateUrl: './pb.header.component.html',
  styleUrls: ['./pb.header.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    PBHeaderModule,
    TranslateModule
  ]
})
export class PbHeaderComponent implements OnInit {

  public confirmLogoutModal: any;
  public showLogout!: boolean;
  public languagesList:Array<string> = [];
  public activeLanguage: string | undefined;
  public langSelectDisbled: boolean = true;
  public getThemeName?: string;
  public modalInfo: ModalInfo = {
    modalTitle: '',
    modalBody: '',
    activeBtnText: '',
    inactiveBtnText: '',
  };
  constructor(
    private translate: TranslateService,
    private appService: CommonService,
  ) { }

  ngOnInit() {
    this.getThemeName = getAppThemeName();
    this.appService._isUserLoggedin.subscribe(status => this.showLogout = status)
    this.confirmLogoutModal = document.getElementById('confirmLogout');
    this.setLangInfo();
  }

  setLangInfo() {
    this.appService._languageData.subscribe(data => {
      this.activeLanguage = data.activeLang;
      this.languagesList = data.langList;
      this.translate.use(data.activeLang);
      this.translate.get('HEADER.logout_popup').subscribe(langData => {
        this.modalInfo = {
          modalTitle: langData.title,
          modalBody: langData.body,
          activeBtnText: langData.cancel,
          inactiveBtnText: langData.yes
        };
      });
    });
    this.appService._langSelectionEnabled.subscribe(isEnabled => this.langSelectDisbled = !isEnabled);
  }

  protected readonly sessionStorage = sessionStorage;
  protected readonly getAppThemeName = getAppThemeName;
}
